import { Pipe, PipeTransform } from '@angular/core'
import { DomSanitizer } from '@angular/platform-browser'

@Pipe({
    name: 'base64'
})
export class Base64Pipe implements PipeTransform {
    constructor(
        private _sanitizer: DomSanitizer
    ) { }
    transform(value: string): any {
        return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,' + value)
    }
}